<template>
  <div v-if="authenticated">
    <EditItem
      model="herd"
      :item="herd"
      :status="status"
      :fields="fields"
    >
      <FormHerdEdit
        :item="herd"
        :id="id"
      />
    </EditItem>
    <p>List herd items</p>
  </div>
  <div class="unauthenticated-message" v-else>
    <p>Login to update your herd</p>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EditItem from '../../layouts/EditItem/EditItem';
import FormHerdEdit from '../../components/FormHerdEdit/FormHerdEdit';

export default {
  name: 'HerdEdit',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fields: [
        'name',
        'visibility',
        'notes'
      ]
    };
  },
  components: {
    FormHerdEdit,
    EditItem
  },
  mounted() {
    if (!Object.keys(this.herd).length) {
      this.fetchHerd(this.id);
    }
  },
  computed: {
    ...mapState({
      status: state => state.herd.status,
      authenticated: state => state.currentUser.authenticated,
    }),
    herd() {
      const herd = this.$store.getters['herd/getHerdById'](this.id)

      if (herd) {
        return herd;
      }

      return {};
    },
  },
  methods: {
    fetchHerd(id) {
      this.$store.dispatch('herd/FETCH', {
        id,
        num: 0
      });
    }
  }
};
</script>

<style scoped>
.unauthenticated-message {
  width: 100%;
  height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
